import { __assign, __read } from "tslib";
import React, { createContext, useEffect, useState } from 'react';
import { readAdminPolicy } from './readAdminPolicy';
import { readFeatureGates } from './readFeatureGates';
import { readFeatureSettings } from './readFeatureSettings';
import { readIdentity } from './readIdentity';
import { readUserEntitlements } from './readUserEntitlements';
var initialState = {
    identity: readIdentity(),
    featureGates: readFeatureGates(),
    featureSettings: readFeatureSettings(),
    userEntitlements: {},
    adminPolicy: readAdminPolicy(),
    isStandaloneCopilot: null,
};
export var OfficeHomeContext = createContext(initialState);
export var OfficeHomeContextProvider = function (props) {
    var _a, _b;
    var _c = __read(useState(initialState), 2), officeHomeStore = _c[0], setOfficeHomeStore = _c[1];
    var _d = __read(useState(false), 2), isUserEntitlementsLoaded = _d[0], setIsUserEntitlementsLoaded = _d[1];
    useEffect(function () {
        var userEntitlements = readUserEntitlements(officeHomeStore.identity, props.workload);
        setOfficeHomeStore(function (prevState) { return (__assign(__assign({}, prevState), { userEntitlements: userEntitlements })); });
        setIsUserEntitlementsLoaded(true);
    }, [props.workload, officeHomeStore.identity]);
    var shouldBlockRenderTillUELoaded = ((_b = (_a = officeHomeStore.featureGates) === null || _a === void 0 ? void 0 : _a.officeHomeContextGates) === null || _b === void 0 ? void 0 : _b.officeHomeContextBlockForUeEnabled) || false;
    if (shouldBlockRenderTillUELoaded && !isUserEntitlementsLoaded)
        return null;
    return (React.createElement(OfficeHomeContext.Provider, { value: __assign(__assign({}, officeHomeStore), { isStandaloneCopilot: props.isStandaloneCopilot }) }, props.children));
};
//# sourceMappingURL=OfficeHomeContext.js.map